/** Toutes les sagas de l'application
 * @module
 */

import watchSkiresorts from './../skiresorts/saga';
import watchGroomers from './../groomers/saga';
import watchMessages from './../messages/saga';
import watchUser from './../user/saga';
import watchUsers from './../users/saga';
import watchPlanning from './../planning/saga';
import watchUpdates from './../updates/saga';

export default function*() {
  yield [
    watchSkiresorts(),
    watchGroomers(),
    watchMessages(),
    watchUser(),
    watchPlanning(),
    watchUsers(),
    watchUpdates()
  ]
}



// WEBPACK FOOTER //
// ./src/redux/_commons/sagas.js